import type { RouteRecordRaw } from 'vue-router';
import ManageAvatarPage from './pages/ManageAvatarPage/ManageAvatarPage.vue';

export const main: RouteRecordRaw[] = [
  {
    name: 'avatar.manage',
    path: 'avatar',
    component: ManageAvatarPage,
    meta: {
      requiresAuth: true,
      headerTitle: 'AVATAR_MANAGEMENT',
    },
  },
];

export const school: RouteRecordRaw[] = [];

// export const base: RouteRecordRaw[] = []
